import React from 'react';

import { calculateWidth } from '../../tools';
import { useStyles } from '../../useStyles';
import { CustomInput } from '../../../../CustomInput/CustomInput';

const InputField = ({
    defaultValue = '',
    id,
    length,
    maxRows,
    minRows,
    multiline,
    onChange,
    onFocus,
    onClick,
    required,
    title,
    type,
    underlineType,
    validator,
    onBlur,
    shortcuts,
}) => {
    const classes = useStyles();

    return (
        <CustomInput
            {...{ minRows, maxRows, onClick, onFocus, onBlur, required, shortcuts }}
            key={`${defaultValue}:${id}`}
            label={title.toUpperCase()}
            name={id}
            type={type.toLowerCase()}
            multiline={Boolean(multiline)}
            placeholder={title.toUpperCase()}
            validator={validator}
            className={classes.container}
            defaultValue={defaultValue}
            onEditField={onChange}
            InputProps={{
                className: classes[`input${underlineType}`],
            }}
            style={{
                flexBasis: calculateWidth(length),
            }}
        />
    );
};

export { InputField };
